import { useSelector } from "react-redux";

import { useEffect, useState } from "react";
import {
  getError,
  getLoading,
  getProject,
  getProjectBaseMapName,
  getProjectDateFilter,
  getProjectSrid,
  getProjectTitle,
  getProjectView,
} from "./selectors";
import { getLocation } from "../location/selectors";
import { getProjectTempConfig } from "../projectConfig";
import { useAction } from "../../hooks/useAction";
import { updateProject } from "./project";
import { ProjectInfo } from "../../interfaces/resourceInfo";
import { ProjectInfoMeta } from "../../hooks/project/useProjectByName";

export function useProjectInfo(): [ProjectInfo, Partial<ProjectInfoMeta>] {
  const project = useSelector(getProject);
  const tempConfig = useSelector(getProjectTempConfig);
  const loading = useSelector(getLoading);
  const error = useSelector(getError);

  return [tempConfig || project, { loading, error }];
}

export const useProjectTitle = () => useSelector(getProjectTitle);

export const useProjectSrid = () => {
  const projectSrid = useSelector(getProjectSrid);
  const location = useSelector(getLocation);
  const [srid, setSrid] = useState(projectSrid);

  const { srid: locationSrid } = location.query || {};

  useEffect(() => {
    if (projectSrid) {
      setSrid(projectSrid);
    }
  }, [projectSrid]);

  useEffect(() => {
    if (locationSrid) {
      setSrid(locationSrid);
    }
  }, [locationSrid]);

  return srid;
};

export const useProjectView = () => useSelector(getProjectView);

export const useProjectBaseMapName = () => useSelector(getProjectBaseMapName);

export const useProjectUpdate = () => useAction(updateProject);

export const useProjectDateFilter = () => {
  const loading = useSelector(getLoading);
  const error = useSelector(getError);

  return [useSelector(getProjectDateFilter), { loading, error }];
};
